import React from 'react';
import PropTypes from 'prop-types';

import ClientDescriptionEdit from './ClientDescriptionEdit';
import ClientDescriptionView from './ClientDescriptionView';

const DescriptionBox = (props) => {
  const [isEditing, setIsEditing] = React.useState(false);

  const {
    clientData,
    clientBackend,
  } = props;

  if (isEditing) {
    return (
      <ClientDescriptionEdit
        clientData={clientData}
        clientBackend={clientBackend}
        setIsEditing={setIsEditing}
      />
    );
  } else {
    return (
      <ClientDescriptionView
        clientData={clientData}
        setIsEditing={setIsEditing}
      />
    );
  }
};
DescriptionBox.propTypes = {
  clientData: PropTypes.object.isRequired,
  clientBackend: PropTypes.object.isRequired,
};

export default React.memo(DescriptionBox);
